






import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomIconEraser extends ComponentVue {}
